/*
 *    Avetti Commerce
 *
 *    NOTICE OF LICENSE
 *
 *    This source file is subject to the Avetti Enterprise License (AEL 1.20)
 *    that is bundled with this package in the file AELICENSE.txt.
 *
 *    Copyright(c)2020. Avetti.com Corporation. (http://www.avetticommerce.com)
 *    License:   Avetti Enterprise License (AEL 1.20)
 *
 *    COPYRIGHT Avetti.com Corporation 1998-2020.  All Rights Reserved
 */

import {
  SWITCH_BETWEEN_LTR_TO_RTL,
  SET_LOGIN_STATE,
  SET_AUTH_STATE
} from "../types";

export const switchDirection = data => ({
  type: SWITCH_BETWEEN_LTR_TO_RTL,
  payload: data
});

export const setLoginState = data => ({
  type: SET_LOGIN_STATE,
  payload: data
});

export const setAuthorizationState = data => ({
  type: SET_AUTH_STATE,
  payload: data
});
